import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import styled from 'styled-components';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { ticketHasActiveSLAs } from 'conversations-thread-data/tickets/public/operators';
import TicketToolbarContent from './TicketToolbarContent';
import { SLATag } from 'svh-workspace-ui-lib/sla-tag/public/components';
import { useSelector } from 'react-redux';
import { hasSLAAlertsAccess } from '../../selectors/userSelectors/hasSLAAlertsAccess';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketToolbar = ({
  ticket,
  threadId,
  inboxId
}) => {
  const hasAlertsAccess = useSelector(hasSLAAlertsAccess);
  const StyledDiv = styled.div.withConfig({
    displayName: "TicketToolbar__StyledDiv",
    componentId: "sc-42os4j-0"
  })(["height:45px;display:flex;align-items:center;"]);
  if (!ticket) {
    return /*#__PURE__*/_jsx(StyledDiv, {
      role: 'toolbar',
      "aria-busy": true,
      children: /*#__PURE__*/_jsx(SkeletonText, {
        width: 250
      })
    });
  }
  const showSLATag = hasAlertsAccess && ticketHasActiveSLAs(ticket);
  return /*#__PURE__*/_jsx(UIMediaObject, {
    itemRight: showSLATag ? /*#__PURE__*/_jsx(SLATag, {
      ticket: ticket
    }) : undefined,
    align: "center",
    "data-test-id": "ticket-toolbar",
    children: /*#__PURE__*/_jsx(UIMediaBody, {
      children: /*#__PURE__*/_jsx(TicketToolbarContent, {
        ticket: ticket,
        threadId: threadId,
        inboxId: inboxId
      })
    })
  });
};
TicketToolbar.displayName = 'TicketToolbar';
export default TicketToolbar;